import { render } from "./CompanyInformation.vue?vue&type=template&id=47bd987b"
import script from "./CompanyInformation.vue?vue&type=script&lang=js"
export * from "./CompanyInformation.vue?vue&type=script&lang=js"

import "./CompanyInformation.vue?vue&type=style&index=0&id=47bd987b&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__